import { DiscountInfo } from 'types/DiscountInfo';

export const getDiscountPriceFromDiscountInformation = (subscriptionId: string, discountInfo: DiscountInfo | null) => {
  if (discountInfo?.lines) {
    const currentLine = discountInfo?.lines.find((line) => String(line.id) === String(subscriptionId));
    return currentLine ? currentLine.line_discounted_price.amount : null;
  }
  return null;
};
